import {html, css, LitElement} from 'lit';

export default class NestedFieldsInput extends LitElement {
  
  static properties = {
    name: { type: String },
    action: { type: String },
    fieldName: { type: String },
    existingRecords: { type: Array },
    label: { type: String },
    placeholder: { type: String },
    disabled: { type: Boolean, default: false },
    codeIndex: { type: Number }
  }

  // disable shadow dom to use global styles 
  createRenderRoot() {
    return this;
  }

  constructor() {
    super();
    this.name = this.getAttribute("name");
    this.action = this.getAttribute("action") || "Add Another";
    this.fieldName = this.getAttribute("field-name") || "name";
    this.existingRecords = JSON.parse(this.getAttribute("existing-records")) || [];
    this.label = this.getAttribute("label") || "Name";
    this.placeholder = this.getAttribute("placeholder") || "Enter value";
    this.disabled = this.getAttribute("disabled");
    this.codeIndex = this.existingRecords.length;
  }

  connectedCallback() {
    super.connectedCallback();
  }

  addField() {
    if (this.disabled) return;
    
    // Add a new empty record to the array
    this.existingRecords = [...this.existingRecords, { id: null, name: '', isNew: true, index: this.codeIndex }];
    this.codeIndex++;
    this.requestUpdate();
  }

  removeField(index) {
    if (this.disabled) return;
    
    const record = this.existingRecords[index];
    if (record.id) {
      // Mark existing record for destruction
      this.existingRecords[index] = { ...record, _destroy: true };
    } else {
      // Remove new record completely
      this.existingRecords.splice(index, 1);
    }
    this.requestUpdate();
  }

  updateField(index, value) {
    this.existingRecords[index] = { ...this.existingRecords[index], name: value };
    this.requestUpdate();
  }

  getFieldName(record, field, index) {
    return `${this.name}[${index}][${field}]`;
  }

  render() {
    return html`
      <div class="nested-fields-input">
        <div class="existing-fields">
          ${this.existingRecords.map((record, index) => html`
            <div class="field-field ${record._destroy ? 'marked-for-destruction' : ''}" 
                style="${record._destroy ? 'display: none;' : ''}">
              ${record.id ? html`
                <input type="hidden" name="${this.getFieldName(record, 'id', index)}" value="${record.id}" />
              ` : ''}
              <input type="hidden" name="${this.getFieldName(record, '_destroy', index)}" value="${record._destroy ? '1' : '0'}" />
              <input 
                type="text" 
                name="${this.getFieldName(record, this.fieldName, index)}" 
                value="${record.name || ''}"
                placeholder="${this.placeholder}"
                class="form-control flex-1"
                ?disabled="${this.disabled}"
                @input="${(e) => this.updateField(index, e.target.value)}"
              />
              ${!this.disabled ? html`
                <svg class="delete" @click="${e => this.removeField(index)}" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.41663 9.5C5.14048 9.5 4.91663 9.72386 4.91663 10C4.91663 10.2761 5.14048 10.5 5.41663 10.5H14.5833C14.8594 10.5 15.0833 10.2761 15.0833 10C15.0833 9.72386 14.8594 9.5 14.5833 9.5H5.41663Z" fill="#859CA4"/>
                </svg>
              ` : ''}
            </div>
          `)}
        </div>
        
        ${!this.disabled ? html`
          <button type="button" class="button" @click="${this.addField}">
            ${this.action}
          </button>
        ` : ''}
      </div>
    `;
  }
}

customElements.define('nested-fields-input', NestedFieldsInput);
